<app-header></app-header>

<section id="retalk" class="bg-grey reset-section-pad2" *ngIf="isDataLoaded">

  <div class="container">

    <div class="row">
      <p class="fw-bold rco mb-2">#retalk</p>
      <app-title-section [titleTxt]="retalkStaticData.titleTxt"></app-title-section>

      <div class="col-lg-8 mt-lg-5 mt-md-0">

        <p class="fw-bold" [innerHTML]="retalkStaticData.subtitleText"></p>
        <p [innerHTML]="retalkStaticData.mainText"></p>
      </div>
    </div>



    <div class="row">
      <div class="col-lg-12  retalk-blq">


        <!-- <app-podcast-listing-block class="col-lg-4 col-md-6 col-sm-6 col-12 retalk-blq-inner"
                 *ngFor="let item of podcastBlock_items | reverse; index as i"
                 [podcastBlock_item]="podcastBlock_items[i]"
                 ></app-podcast-listing-block> -->
        <app-podcast-listing-block class="col-lg-4 col-md-6 col-sm-6 col-12 retalk-blq-inner"
          *ngFor="let item of retalkData | reverse; index as i"
          [podcastBlock_item]="retalkData[i]"></app-podcast-listing-block>





      </div>
    </div>





  </div>


</section>


<app-footer-main></app-footer-main>